import { Component, OnInit, Input } from '@angular/core';

import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

import { IAvailabilityPeriod, IProductTypeAvailability } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'product-availability-info',
  template: `<div *ngIf="availabilityInfo" [ngClass]="cssClass">{{ availabilityInfo }}</div>`,
})
export class ProductAvailabilityInfoComponent implements OnInit {
  @Input() availability: IProductTypeAvailability;
  @Input() cssClass = '';

  public availabilityInfo: string;
  public readonly today: Date = new Date();

  constructor(private _translate: TranslateService) {
  }

  ngOnInit() {
    if (this.availability) {
      const { availableAlways, availablePeriod, unavailablePeriod } = this.availability;
      this.availabilityInfo = availableAlways
        ? this._getUnavailablePeriod(unavailablePeriod)
        : this._getAvailabilityPeriod(availablePeriod);
    }
  }

  private _getUnavailablePeriod(periods: IAvailabilityPeriod[]) {
    if (!periods) {
      return;
    }

    if (periods.length === 1) {
      return this._translate.instant('cakeBuilder.productInfo.unavailableInfo', {
        dateBegin: periods[0].begin,
        dateEnd: periods[0].end
      });
    } else {
      const periodsStr = periods
        .filter(day => moment(day.end, 'DD.MM.YYYY').diff(moment(this.today), 'days') >= 0)
        .sort((d1, d2) => moment(d1.begin).diff(moment(d2.begin)))
        .map(period => period.begin + '-' + period.end).join(', ');

      return this._translate.instant('cakeBuilder.productInfo.unavailablePeriodsInfo', {
        periods: periodsStr
      });
    }
  }

  private _getAvailabilityPeriod(period: { begin: string, end: string }): string {
    if (!period) {
      return '';
    }

    const dateBegin = moment(period.begin, 'DD.MM.YYYY');
    const dateEnd = moment(period.end, 'DD.MM.YYYY');
    const _isOneDayAvailable = dateBegin.diff(dateEnd) === 0;

    return _isOneDayAvailable
      ? this._translate.instant('cakeBuilder.productInfo.availableOnly', { date: dateEnd.format('D MMMM') })
      : this._translate.instant('cakeBuilder.productInfo.availableFromUntil', {
        dateBegin: period.begin,
        dateEnd: period.end
      });
  }
}
